export default __webpack_public_path__ + "static/media/homeowner.c292e31c.webp";